import React from 'react'
import Header from 'components/Client/Header/Header'
import EllevestBalance from 'components/Client/Header/EllevestBalance/EllevestBalance'
import withTechnicalDifficultiesErrorMessage from 'components/Client/withTechnicalDifficultiesErrorMessage'
import DedicatedTeam from '../DedicatedTeam/DedicatedTeam'
import withLoadingState from '../withLoadingState'
import GoalsAndInvestmentStrategyBase from '../GoalsAndInvestmentStrategy/GoalsAndInvestmentStrategyBase'
import FinancialAccountsList from 'components/Client/FinancialAccountsList/FinancialAccountsList'
import LoadingComponent from 'components/Client/LoadingComponent/LoadingComponent'
import PortfolioOverview from 'components/Client/PortfolioOverview/PortfolioOverview'
import WelcomeNotification from 'components/Client/WelcomeNotification/WelcomeNotification'
import PropTypes from 'prop-types'
import styles from './OverviewPage.module.scss'

const OverviewPage = (props) => {
  const {
    primaryPortfolio,
    investmentPlans,
    teamMembers,
    currentInvestmentPlan,
    blackDiamondError,
    loadingPortfolioAccounts,
    firstTeamMember,
    nextTeamMembers,
    notifications,
    isMobile,
    setNotificationUserDismissed,
  } = props

  const {
    totalEmv,
    financialAccounts
  } = primaryPortfolio

  const EllevestBalanceHeader = <EllevestBalance>{ totalEmv }</EllevestBalance>

  const BlackDiamondHeader = withTechnicalDifficultiesErrorMessage(EllevestBalanceHeader)

  const HeaderComponent = (
    <Header>
      <BlackDiamondHeader showError={blackDiamondError} context="portfolio" layout="header" />
    </Header>
  )

  const AccountsListComponent = (
    <FinancialAccountsList
      className={styles.financialAccountsList}
      showMarketValue={true}
      financialAccounts={financialAccounts}
      isAccountNumberMasked={true} />
  )
  const AccountsListWithLoading = withLoadingState(AccountsListComponent, <LoadingComponent />)

  return (
    <div className={styles.OverviewPage}>
      {HeaderComponent}
      {notifications.length > 0 &&
        <WelcomeNotification
          isMobile={isMobile}
          teamMembers={teamMembers}
          notifications={notifications}
          setNotificationUserDismissed={setNotificationUserDismissed} />
      }
      {!blackDiamondError &&
        <div>
          <PortfolioOverview
            primaryPortfolio={primaryPortfolio}
            isMobile={isMobile}
            showLinkToPortfolioPage={true} />
          <AccountsListWithLoading loading={loadingPortfolioAccounts} />
        </div>
      }
      { investmentPlans.length > 0 &&
        <GoalsAndInvestmentStrategyBase currentInvestmentPlan={currentInvestmentPlan} />
      }
      { teamMembers.length > 0 &&
        <DedicatedTeam
          isMobile={isMobile}
          firstTeamMember={firstTeamMember}
          nextTeamMembers={nextTeamMembers} />
      }
    </div>
  )
}

OverviewPage.propTypes = {
  primaryPortfolio: PropTypes.object,
  teamMembers: PropTypes.array,
  investmentPlans: PropTypes.array,
  firstTeamMember: PropTypes.object,
  nextTeamMembers: PropTypes.array,
  notifications: PropTypes.array,
  loadingPortfolioAccounts: PropTypes.bool,
  currentInvestmentPlan:  PropTypes.object,
  blackDiamondError: PropTypes.bool,
  clientNavOpen: PropTypes.bool,
  isMobile: PropTypes.bool,
  setNotificationUserDismissed: PropTypes.func,
}

OverviewPage.defaultProps = {
  primaryPortfolio: {},
  teamMembers: [],
  investmentPlans: [],
  firstTeamMember: {},
  nextTeamMembers: [],
  notifications: [],
  loadingPortfolioAccounts: false,
  currentInvestmentPlan: {},
  blackDiamondError: false,
  clientNavOpen: false,
  isMobile: false,
  setNotificationUserDismissed: () => {},
}

export default OverviewPage



// WEBPACK FOOTER //
// ./src/components/Client/OverviewPage/OverviewPage.jsx